// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.app-container[data-v-40c95f6c] .drawerClass header {\n  border-bottom: 1px solid #ccc !important;\n  margin-bottom: 0 !important;\n  padding: 20px 20px 20px !important;\n}\n", ""]);
// Exports
module.exports = exports;
